import { FormControl } from '@angular/forms';

// When using AutoComplete with chips inside a MatFormField,
// the value won't get set on the input directly from FormControl.setValue().
// Instead, the value is passed to the _control on the MatFormField, which in most cases would be the MatChipList.
// So, you have multiple options to fix this:
// 1) manually set the _control on the MatFormField to a MatInput
// 2) manually set the value on the input element.
// The example (https://v16.material.angular.io/components/chips/overview#autocomplete)
// uses option 2.
//
// More links:
// https://github.com/angular/components/blob/15.2.9/src/material/autocomplete/autocomplete-trigger.ts#L595-L605
// https://github.com/angular/components/issues/8176
export function setChipAutoCompleteText<TFormControlValue>(
  value: string,
  input: HTMLInputElement,
  formControl: FormControl<TFormControlValue | string>
): void {
  input.value = value;
  formControl.setValue(value);
}
